// eslint-disable-next-line max-lines-per-function
export const HandsSvg = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="96" height="49" viewBox="0 0 96 49" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M42.4129 5.01476C41.0967 4.99092 39.9958 5.42267 39.0788 6.30572C37.8943 7.44648 37.4435 8.85661 37.6474 10.468C37.8039 11.7053 38.4287 12.7106 39.3046 13.5817C41.5726 15.8373 43.8294 18.1039 46.0926 20.3642C46.6582 20.929 47.2374 21.4804 47.799 22.0492C48.0131 22.2659 48.1642 22.2784 48.3914 22.0464C49.11 21.3122 49.8574 20.6064 50.5851 19.8813C52.112 18.3599 53.6394 16.8388 55.1552 15.3063C55.9875 14.4649 56.8734 13.6604 57.5984 12.7326C58.7179 11.2996 58.9156 9.63712 58.24 7.96002C56.8992 4.63033 52.8233 4.17886 50.5371 6.21296C49.9618 6.72478 49.4402 7.2961 48.8821 7.82748C48.3838 8.30175 47.8091 8.29643 47.3278 7.82662C46.9293 7.43756 46.5409 7.03856 46.1449 6.64728C45.0996 5.61471 43.8868 4.96846 42.4129 5.01476ZM35.5539 9.77892C35.5527 6.4314 37.9278 3.58336 41.234 3.0537C43.4598 2.69706 45.4454 3.27901 47.1279 4.80968C47.3706 5.03036 47.6194 5.24657 47.8411 5.48714C48.0369 5.69976 48.1765 5.67369 48.3652 5.47651C48.9487 4.86695 49.5736 4.30694 50.317 3.8896C51.2645 3.35737 52.2668 3.05027 53.3597 2.98597C55.0853 2.88481 56.6357 3.32873 58 4.38205C59.536 5.56756 60.4043 7.14761 60.5957 9.07059C60.8095 11.2199 60.1783 13.1206 58.659 14.6597C55.469 17.8913 52.244 21.0883 49.0315 24.2974C48.352 24.9764 47.8342 24.9675 47.1249 24.2592C44.337 21.4751 41.5466 18.6932 38.7709 15.8968C38.0891 15.2101 37.4083 14.511 36.8188 13.747C35.9734 12.651 35.5544 11.1782 35.5539 9.77892ZM64.6658 23.0327C64.7882 23.0545 64.8558 23.0715 64.9244 23.0782C66.9686 23.2805 67.8864 25.0788 67.6402 26.8298C67.4819 27.9572 66.9766 28.9174 66.2224 29.7502C65.3402 30.724 64.4412 31.6826 63.5495 32.6476C62.8419 33.4134 62.1394 34.184 61.4241 34.9422C61.0336 35.3559 60.5312 35.4204 60.1094 35.1423C59.5613 34.7808 59.476 34.1173 59.9361 33.5854C60.3563 33.0995 60.8063 32.6394 61.2397 32.165C62.4635 30.8262 63.6982 29.4973 64.9019 28.1407C65.3877 27.5932 65.6286 26.9183 65.6399 26.1759C65.6502 25.5071 65.2592 25.11 64.5842 25.0994C63.7562 25.0864 63.0876 25.4631 62.5324 26.0236C61.7186 26.8449 60.9304 27.6928 60.1566 28.5522C58.6335 30.244 57.0145 31.828 55.1652 33.167C54.5301 33.6267 53.8876 34.0837 53.3006 34.601C52.0087 35.7392 51.2725 37.1224 51.3253 38.9178C51.3896 41.1014 51.3405 43.2883 51.3405 45.4736V45.9155H59.5866C59.6082 45.3441 59.6069 44.8323 59.6506 44.3243C59.7617 43.0318 60.0278 41.8113 60.8653 40.7367C63.5161 37.3353 66.1208 33.8981 68.7484 30.4788C68.9046 30.2758 68.9811 30.075 68.9761 29.815C68.9612 29.0441 68.9706 28.2725 68.9706 27.5013C68.9706 22.3162 68.9699 17.1311 68.9715 11.9461C68.9716 11.3902 68.8665 10.871 68.528 10.4122C67.8401 9.47924 66.584 9.58366 66.0905 10.6286C65.9888 10.8443 65.9201 11.0874 65.8921 11.3244C65.7692 12.3732 65.6673 13.4247 65.5564 14.4751C65.3678 16.2633 65.1762 18.0513 64.9895 19.8397C64.8798 20.8887 64.7764 21.9383 64.6658 23.0327ZM70.9731 20.8948C70.9731 24.0095 70.9675 27.1242 70.9793 30.2388C70.981 30.7069 70.8481 31.0867 70.5625 31.4576C67.8787 34.9433 65.22 38.4483 62.5209 41.922C61.9791 42.6192 61.7639 43.3882 61.7092 44.2179C61.6555 45.0281 61.6675 45.8443 61.6826 46.657C61.6993 47.5397 61.3545 47.9252 60.4716 47.933C57.1712 47.9624 53.871 47.99 50.5708 48.0154C49.6718 48.0224 49.3106 47.6736 49.3092 46.7859C49.3052 44.0142 49.3142 41.2423 49.3056 38.4707C49.2992 36.473 50.1322 34.8336 51.5288 33.4907C52.3573 32.6941 53.3093 32.0228 54.2265 31.3223C55.6044 30.2701 56.877 29.1061 58.0519 27.833C58.9527 26.8565 59.837 25.8632 60.7704 24.9188C61.2271 24.4567 61.7646 24.0688 62.2951 23.6885C62.489 23.5495 62.5953 23.4222 62.6187 23.1909C62.7936 21.4576 62.9746 19.7248 63.1555 17.9921C63.3707 15.9328 63.5878 13.8738 63.8042 11.8149C63.8445 11.4322 63.8554 11.0433 63.9321 10.6678C64.2334 9.19456 65.3721 8.02945 66.7117 7.79352C68.2124 7.52929 69.664 8.23504 70.4303 9.59167C70.8274 10.2949 70.9803 11.0466 70.9774 11.8509C70.9666 14.8656 70.9731 17.8801 70.9731 20.8948ZM44.8493 45.9191V45.4172C44.8493 43.1746 44.8258 40.9317 44.8587 38.6896C44.8767 37.4535 44.498 36.382 43.7074 35.4616C43.2912 34.9771 42.8312 34.5182 42.3355 34.1163C41.5157 33.4515 40.6356 32.8613 39.8084 32.2051C38.2698 30.9845 36.9437 29.5442 35.6262 28.0958C34.9729 27.3775 34.3121 26.6648 33.6254 25.9789C33.0616 25.416 32.3761 25.0799 31.5546 25.1005C31.0112 25.114 30.6331 25.4508 30.5853 25.9895C30.564 26.2274 30.587 26.4741 30.6242 26.7116C30.7394 27.448 31.1575 28.0298 31.6422 28.5605C33.0674 30.1217 34.5062 31.6705 35.9379 33.2257C36.0926 33.3936 36.2546 33.5589 36.3817 33.7468C36.7073 34.2286 36.5816 34.8046 36.0974 35.1309C35.6653 35.4217 35.1759 35.3661 34.7867 34.9481C33.1514 33.1921 31.5083 31.443 29.8998 29.6628C29.1801 28.8665 28.7072 27.9127 28.5543 26.8397C28.4308 25.9722 28.5428 25.1317 29.0466 24.376C29.4797 23.7262 30.086 23.3316 30.8487 23.1401C30.8487 22.9805 30.8538 22.8397 30.8478 22.6993C30.7525 20.4449 30.6588 18.1903 30.5582 15.9362C30.492 14.4523 30.4352 12.9676 30.3295 11.4865C30.3032 11.119 30.1624 10.7283 29.9713 10.4102C29.527 9.67065 28.6407 9.56743 27.9781 10.1206C27.4159 10.5901 27.2343 11.2108 27.2343 11.9134C27.2357 17.8842 27.2366 23.855 27.2304 29.8256C27.23 30.0845 27.3017 30.2834 27.4584 30.4874C30.0435 33.8495 32.6012 37.233 35.2135 40.5739C36.0068 41.5886 36.401 42.7047 36.5113 43.951C36.5674 44.5861 36.5862 45.2245 36.625 45.9191H44.8493ZM40.6995 47.9336C39.0279 47.9336 37.3561 47.9382 35.6845 47.9315C34.887 47.9283 34.5028 47.531 34.5244 46.7378C34.5557 45.5807 34.6173 44.419 34.344 43.2836C34.25 42.8933 34.0792 42.4892 33.8378 42.1715C31.1412 38.6233 28.4288 35.087 25.7066 31.5585C25.348 31.0936 25.1804 30.6142 25.1816 30.024C25.1944 23.9943 25.1915 17.9645 25.1879 11.9348C25.1872 10.6277 25.5781 9.48795 26.5781 8.60747C28.1707 7.20523 30.5164 7.5233 31.6888 9.29419C32.142 9.97868 32.3483 10.7376 32.3821 11.5562C32.4709 13.7117 32.5726 15.8665 32.6708 18.0213C32.7444 19.6341 32.8299 21.2464 32.8874 22.8595C32.8977 23.15 32.9901 23.2846 33.2574 23.3842C34.2161 23.7415 34.9775 24.3825 35.6692 25.118C37.0293 26.5645 38.3484 28.0528 39.77 29.4359C40.6863 30.3272 41.7271 31.0996 42.7614 31.858C44.268 32.9628 45.6096 34.1927 46.3872 35.9373C46.7239 36.6928 46.881 37.4822 46.8831 38.3073C46.8904 41.1221 46.9035 43.9369 46.9096 46.7517C46.9115 47.6628 46.5437 48.0174 45.6288 48.0167C43.9858 48.0155 42.3427 48.0164 40.6995 48.0164V47.9336Z"
			fill="url(#paint0_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M85 23.7007C85 22.8723 85.767 22.2007 86.7132 22.2007H94.2868C95.233 22.2007 96 22.8723 96 23.7007C96 24.5291 95.233 25.2007 94.2868 25.2007H86.7132C85.767 25.2007 85 24.5291 85 23.7007Z"
			fill="url(#paint1_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0 23.7007C0 22.8723 0.767025 22.2007 1.7132 22.2007H9.2868C10.233 22.2007 11 22.8723 11 23.7007C11 24.5291 10.233 25.2007 9.2868 25.2007H1.7132C0.767025 25.2007 0 24.5291 0 23.7007Z"
			fill="url(#paint2_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.49023 2.2998L15.3734 5.71876L9.49023 2.2998Z"
			fill="url(#paint3_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.54438 1.52773C6.97081 0.793948 7.91135 0.544787 8.64514 0.971218L14.5283 4.39017C15.2621 4.8166 15.5113 5.75715 15.0849 6.49093C14.6584 7.22472 13.7179 7.47388 12.9841 7.04745L7.1009 3.62849C6.36711 3.20206 6.11795 2.26152 6.54438 1.52773Z"
			fill="url(#paint4_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.54438 46.8961C6.97081 47.6299 7.91135 47.879 8.64514 47.4526L14.5283 44.0337C15.2621 43.6072 15.5113 42.6667 15.0849 41.9329C14.6584 41.1991 13.7179 40.95 12.9841 41.3764L7.1009 44.7953C6.36711 45.2218 6.11795 46.1623 6.54438 46.8961Z"
			fill="url(#paint5_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M90.8384 46.8961C90.412 47.6299 89.4715 47.879 88.7377 47.4526L82.8545 44.0337C82.1207 43.6072 81.8715 42.6667 82.298 41.9329C82.7244 41.1991 83.6649 40.95 84.3987 41.3764L90.2819 44.7953C91.0157 45.2218 91.2649 46.1623 90.8384 46.8961Z"
			fill="url(#paint6_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M87.8906 2.2998L82.0074 5.71876L87.8906 2.2998Z"
			fill="url(#paint7_linear_4731_9119)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M90.8384 1.52773C90.412 0.793948 89.4715 0.544787 88.7377 0.971218L82.8545 4.39017C82.1207 4.8166 81.8715 5.75715 82.298 6.49093C82.7244 7.22472 83.6649 7.47388 84.3987 7.04745L90.2819 3.62849C91.0157 3.20206 91.2649 2.26152 90.8384 1.52773Z"
			fill="url(#paint8_linear_4731_9119)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_4731_9119"
				x1="70.9794"
				y1="48.0167"
				x2="70.9794"
				y2="2.95215"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_4731_9119"
				x1="96"
				y1="25.2007"
				x2="96"
				y2="22.2007"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_4731_9119"
				x1="11"
				y1="25.2007"
				x2="11"
				y2="22.2007"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_4731_9119"
				x1="15.3734"
				y1="5.71876"
				x2="15.3831"
				y2="5.70205"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_4731_9119"
				x1="14.3187"
				y1="7.81798"
				x2="15.865"
				y2="5.13963"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint5_linear_4731_9119"
				x1="14.3187"
				y1="40.6058"
				x2="15.865"
				y2="43.2842"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint6_linear_4731_9119"
				x1="83.0641"
				y1="40.6058"
				x2="81.5178"
				y2="43.2842"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint7_linear_4731_9119"
				x1="82.0074"
				y1="5.71876"
				x2="81.9978"
				y2="5.70205"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
			<linearGradient
				id="paint8_linear_4731_9119"
				x1="83.0641"
				y1="7.81798"
				x2="81.5178"
				y2="5.13963"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FE9311" />
				<stop offset="1" stopColor="#FFDB00" />
			</linearGradient>
		</defs>
	</svg>
);
